import { Injectable, inject } from '@angular/core';
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthStorage,
} from 'angular-oauth2-oidc';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { SKIP_BEARER_TOKEN } from '@lyceo/shared/auth/util-models';

@Injectable()
export class OAuthInterceptor implements HttpInterceptor {
  private readonly authStorage: OAuthStorage = inject(OAuthStorage);
  private readonly errorHandler: OAuthResourceServerErrorHandler = inject(
    OAuthResourceServerErrorHandler,
  );
  private readonly moduleConfig: OAuthModuleConfig | null = inject(
    OAuthModuleConfig,
    { optional: true },
  );

  private checkUrl(allowedUrls: string[], url: string): boolean {
    return !!allowedUrls.find((u) => url.startsWith(u));
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      req.context.has(SKIP_BEARER_TOKEN) &&
      req.context.get(SKIP_BEARER_TOKEN)
    )
      return next.handle(req);
    if (!this.moduleConfig) return next.handle(req);
    if (!this.moduleConfig.resourceServer) return next.handle(req);
    if (!this.moduleConfig.resourceServer.allowedUrls) return next.handle(req);
    if (
      !this.checkUrl(
        this.moduleConfig.resourceServer.allowedUrls,
        req.url.toLowerCase(),
      )
    )
      return next.handle(req);

    const token: string | null = this.authStorage.getItem('access_token');
    const header: string = 'Bearer ' + token;
    const headers: HttpHeaders = req.headers.set('Authorization', header);

    req = req.clone({ headers });

    return next
      .handle(req)
      .pipe(catchError((err) => this.errorHandler.handleError(err)));
  }
}
